import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'working_hour_records_are_not_consistent_payroll_other'

export const dataPointDefinition = {
  retracedId: 'working_hour_records_are_not_consistent_payroll_other',
  name: 'Working hour records are not consistent with payroll and other records',
  description:
    'The intent of this option selection is to understand if all working hours records are consistent with (i.e. "in line with") payroll records or other types of records (i.e. broken needle or first-aid kit records).',
  meta: {
    slcpMeta: {
      key: 'wh-wor-26x',
      number: 'WH-WOR-4-5',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-wor-26x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36550,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
